import type { ProductCardDataShows } from '../transforms/shows'
import { MAX_CARDS_DISPLAY } from './base'

/**
 * Get the shows category URL using the current environment's domain
 */
export const getShowsCategoryUrl = (): string => {
  if (typeof window === 'undefined') {
    return '/shows'
  }

  const origin = window.location.origin

  // If origin is empty (localhost), use relative URL
  if (!origin || origin === 'null') {
    return '/shows'
  }

  return `${origin}/shows`
}

export interface LimitedShowsResult {
  cards: ProductCardDataShows[]
  hasMore: boolean
  seeAllUrl: string
}

/**
 * Limits shows cards to MAX_CARDS_DISPLAY and returns info about "See All" CTA
 */
export const limitShowsCards = (cards: ProductCardDataShows[]): LimitedShowsResult => {
  const hasMore = cards.length > MAX_CARDS_DISPLAY
  const limitedCards = cards.slice(0, MAX_CARDS_DISPLAY)

  return {
    cards: limitedCards,
    hasMore,
    seeAllUrl: getShowsCategoryUrl(),
  }
}
